export const VERSION = '19.05.2'